module.exports = __webpack_public_path__ + "static/media/Logout.0b1c3a82.svg";